var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-tabbar',{attrs:{"active-color":"#14B9B5","inactive-color":"#000"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.menuList),function(item){return _c('van-tabbar-item',{attrs:{"to":item.url,"icon":item.icon}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }